import React, {useState} from "react";
import {Button, Col, FormGroup, Modal, Row, Container} from "react-bootstrap";
import {Form, Input, Checkbox } from 'antd';
import {Breadcrumb, ImageElement, LoginHeader} from "../../components";
import {Link } from "react-router-dom"
import DatePicker from 'sassy-datepicker';
import TextArea from "antd/lib/input/TextArea";
import '../../../node_modules/sassy-datepicker/dist/styles.css';

function ServiceProviderDetails() {

    const breadcrumb = [
        {
            path: '/dashboard',
            name: 'Home',
        },
        {
            path: '#',
            name: 'Service Provider Detail / Profile',
        }
        
    ];

    const [date, setDate] = useState(new Date());

    const onChange = newDate => {
      console.log(`New date selected - ${newDate.toString()}`);
      setDate(newDate);
    };
  
    
    const [bookingDetail, setbookingDetail] = useState(false);
    const bookingDetailClose = () => setbookingDetail(false);
    const bookingDetailShow = () =>{
        chooseBookingClose()
        setbookingDetail(true)
    };

    const [showRequested, setRequested] = useState(false);
    const RequestedClose = () => setRequested(false);
    const RequestedShow = () => {
        bookingDetailClose();
        setRequested(true)
    };

    const [chooseBooking, setchooseBooking] = useState(false);
    const chooseBookingClose = () => setchooseBooking(false);
    const chooseBookingShow = () =>{
        setchooseBooking(true)
    };

    return(
        <>            
            <LoginHeader/>         
            <div className="main-content providerDetailPage">
                {/* page content */}
                <div className="pageContent">
                    <div className="pageContent_wide">
                        <Container>
                            <div className="d-flex justify-content-between">
                                <Breadcrumb title="Service Provider Detail" breadcrumb={breadcrumb}/>
                                <Link to="/dashboard" className="btn btn-outline-info ms-2 btn-sm">Back</Link>
                            </div>
                            <div className="detailsBox br-10 p-30 bg-white">
                                <div className="detailsBox_user text-center position-relative">
                                    <ImageElement source="profile-img.png" alt="user"/>
                                    <div className="mt-md-3 mt-2">
                                        <h3 className="font-md">Steven S. Hurd</h3>
                                        <ul className="list-unstyled d-flex starRating mb-0 justify-content-center">
                                            <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                            <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                            <li><em className="info_icon info_icon-gray gg-full-star active"/></li>
                                            <li className="starRating_halfStar"><em className="info_icon info_icon-gray gg-half-star active_half"/></li>
                                            <li><em className="info_icon info_icon-gray gg-star-outline active"/></li>
                                        </ul>
                                    </div>
                                    <div className="appointmentList_like">
                                        <Checkbox defaultChecked><em className="appointmentList_like_icon gg-heart-outline" /></Checkbox>
                                    </div>
                                </div>
                                <div className="detailsBox_desc">
                                    <p className="ft-14">You must be at least 18 years of age to use this Mobile Application. By using this Mobile Application and by agreeing to this Agreement you warrant and represent that you are at least 18 years of age. If you create an account in the Mobile Application, you are responsible for maintaining the security of your account and you are fully responsible for all activities that occur under the account and any other actions taken in connection with it. Providing false contact information of any kind may result in the termination of your account. </p>
                                    <p className="ft-14">You must immediately notify us of any unauthorized uses of your account or any other breaches of security. We will not be liable for any acts or omissions by you, including any damages of any kind incurred as a result of such acts or omissions.</p>
                                </div>
                                <div className="d-flex justify-content-end">
                                    <Link to="/service-provider-contact-us" className="btn btn-secondary min-200">Contact Tech</Link>
                                    {/* <Button variant="primary" className="min-200"  onClick={() => chooseBookingShow()}>CONTINUE BOOKING</Button> */}
                                </div>
                            </div>
                        </Container>
                    </div>
                </div>
            </div>

            {/* Booking Calender */}           
            <Modal show={chooseBooking} onHide={chooseBookingClose} size="xl" centered id="chooseBookingmodal" className="chooseBookingmodal" backdrop="static">
                <Modal.Header closeButton className="align-items-start">
                    <div>
                        <Modal.Title>Choose Booking Date & Time</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="chooseBookingmodal">
                    <Row>
                        <Col lg={6} sm={12}>
                            <div className="selectDate">
                                <h3 className="selectDate_heading">Select Date</h3>
                                <div className="selectDate_content">                   
                                    <DatePicker onChange={onChange} value={date} />
                                </div>
                            </div>
                        </Col>
                        <Col lg={6} sm={12}>
                            <div className="selectTime mt-lg-0 mt-3 d-flex flex-column selectHeight justify-content-between">
                                <h3 className="selectDate_heading">Select Time</h3>
                                <div className="d-flex flex-column selectHeight justify-content-between">                               
                                    <div className="selectTime_content">
                                        <Row>
                                            <Col xl={4} xs={6}>
                                                <div className="slot">
                                                    <input type="checkbox" id="one" name="one" value="one" disabled={true} />
                                                    <label  htmlFor="one"> 5:00 AM – 7:00 AM</label>
                                                </div> 
                                            </Col>
                                            <Col xl={4} xs={6}>
                                                <div className="slot">
                                                    <input type="checkbox" id="one2" name="one2" value="one2"/>
                                                    <label  htmlFor="one2"> 7:00 AM – 9:00 AM</label>
                                                </div>                                            
                                            </Col>
                                            <Col xl={4} xs={6}>
                                                <div className="slot">
                                                    <input type="checkbox" id="one3" name="one3" value="one3"/>
                                                    <label  htmlFor="one3"> 8:00 AM – 11:00 AM</label>
                                                </div>
                                            </Col>
                                            <Col xl={4} xs={6}>
                                                <div className="slot">
                                                    <input type="checkbox" id="one4" name="one4" value="one4" />
                                                    <label  htmlFor="one4"> 11:00 AM – 2:00 PM</label>
                                                </div>
                                            </Col>
                                            <Col xl={4} xs={6}>
                                                <div className="slot">
                                                    <input type="checkbox" id="one5" name="one5" value="one5" disabled={true}/>
                                                    <label  htmlFor="one5"> 2:00 PM – 5:00 PM</label>
                                                </div>
                                            </Col>
                                            <Col xl={4} xs={6}>
                                                <div className="slot">
                                                    <input type="checkbox" id="one6" name="one6" value="one6" disabled={true}/>
                                                    <label  htmlFor="one6"> 2:00 PM – 5:00 PM</label>
                                                </div>
                                            </Col>
                                            <Col xl={4} xs={6}>
                                                <div className="slot">
                                                    <input type="checkbox" id="one7" name="one7" value="one7"/>
                                                    <label  htmlFor="one7"> 5:00 AM – 7:00 AM</label>
                                                </div>
                                            </Col>
                                            <Col xl={4} xs={6}>
                                                <div className="slot">
                                                    <input type="checkbox" id="one8" name="one8" value="one8"/>
                                                    <label  htmlFor="one8"> 8:00 PM – 11:00 PM</label>
                                                </div>
                                            </Col>
                                            <Col xl={4} xs={6}>
                                                <div className="slot">
                                                    <input type="checkbox" id="one9" name="one9" value="one9"/>
                                                    <label  htmlFor="one9">8:00 PM – 11:00 PM</label>
                                                </div>
                                            </Col>
                                            <Col xl={4} xs={6}>
                                                <div className="slot">
                                                    <input type="checkbox" id="one10" name="one10" value="one10"/>
                                                    <label  htmlFor="one10"> 5:00 AM – 7:00 AM</label>
                                                </div>
                                            </Col>
                                            <Col xl={4} xs={6}>
                                                <div className="slot">
                                                    <input type="checkbox" id="one11" name="one11" value="one11"/>
                                                    <label  htmlFor="one11"> 8:00 PM – 11:00 PM</label>
                                                </div>
                                            </Col>
                                            <Col xl={4} xs={6}>
                                                <div className="slot">
                                                    <input type="checkbox" id="one12" name="one12" value="one12"/>
                                                    <label  htmlFor="one12"> 8:00 PM – 11:00 PM</label>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="d-flex justify-content-end align-items-end chooseBookingmodal_button">
                                        {/* <Button  className="btn btn-light" onClick={chooseBookingClose}>CANCEL</Button> */}
                                        <Button className="btn btn-primary ms-3" onClick={bookingDetailShow}>CONTINUE</Button>
                                    </div>                                   
                                </div>
                            </div>
                        </Col>
                    </Row>        
                    </div>    
                </Modal.Body>
            </Modal>

            {/* Booking detail */} 
            <Modal show={bookingDetail} onHide={bookingDetailClose} size="lg" centered id="chooseBookingmodal" className="bookingDetails" backdrop="static">
                    <Modal.Header closeButton className="align-items-start">
                    <div>
                        <Modal.Title>Booking Details</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row className="align-items-center">
                            <Col lg={12} sm={12}>
                                <ul className="bookingDetails list-unstyled mb-0">
                                    <li className="bookingDetails_list d-flex">
                                        <label>Paid Schedule <span>X 1</span></label>
                                        <span className="font-sm">$100</span>
                                    </li>
                                    <li className="bookingDetails_list d-flex">
                                        <label>Provider</label>
                                        <span className="font-sm">James John</span>
                                    </li>
                                    <li className="bookingDetails_list d-flex">
                                        <label>Company Name</label>
                                        <span className="font-sm">Versatile Sash & Woodwork</span>
                                    </li>
                                    <li className="bookingDetails_list d-flex">
                                        <label>Booking Date</label>
                                        <span className="font-sm">Jan 25,2023</span>
                                    </li>
                                    <li className="bookingDetails_list d-flex">
                                        <label>Booking Time</label>
                                        <span className="font-sm">11:00 AM - 02:00 PM</span>
                                    </li>
                                </ul>
                            </Col>
                        </Row>
                        <div className="promoCode">
                            <div className="d-flex align-items-end">
                                <FormGroup className="form-group promoCode_wrapper mb-0">
                                        <label className="ant-label font-md">Promo Code</label>
                                    <Input size="large" placeholder="Promo Code" value="NIT" />
                                </FormGroup>
                                <Button variant="primary" type="submit" className="ms-2 font-sm d-inline-block">APPLY</Button>
                            </div>
                            <div className="promoCode_info mt-2 d-flex align-items-center"><em className="gg-check-circle me-2"/> <span>Promo Code applied!</span></div>
                        </div>
                        <div className="mb-3">
                            <ul className="serviceCost list-unstyled mt-lg-0 mt-3 mb-0">
                                <li className="serviceCost_list">
                                    <label>Total Cost</label>
                                    <span className="font-sm">$98.98</span>
                                </li>      
                            </ul>
                        </div>
                        <FormGroup className="form-group">
                            <label className="ant-label font-md ps-0">Add Special Instruction For Provider Below</label>
                            <TextArea rows={5} />
                        </FormGroup>
                        <div className="d-flex justify-content-end align-items-end mt-lg-4 mt-3  chooseBookingmodal_button">
                            {/* <Button className="btn btn-light" onClick={bookingDetailClose}>CANCEL</Button> */}
                            <Button variant="primary" className=" min-200 ms-3" onClick={RequestedShow}>Confirm Booking</Button>
                        </div>
                    </Form>                   
                </Modal.Body>
            </Modal>

            {/* Booking Requested */}
            <Modal show={showRequested} onHide={RequestedClose} size="lg" centered id="paidEmergency" className="paidEmergencymodel" backdrop="static">
                <Modal.Header closeButton className="align-items-start">
                    <div>
                        <Modal.Title>Booking Requested</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="paidEmergency">
                        <p> Your provider has received the booking request and will get back to you shortly. You can check out the status of your request on the 'Your Bookings' menu item.</p>
                    </div>
                    <div className="d-flex justify-content-flex-end">    
                        <Link to="/my-bookings"  className="btn btn-primary ms-auto min-200">View BOOKING</Link>
                    </div>
                </Modal.Body>
            </Modal> 
        </>
    );
}

export default ServiceProviderDetails;